export default __webpack_public_path__ + "static/media/GWIAZDY_1.bcf5283c.png";